import {createDetailResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const PackageItemSchema = z.object({
  id: z.string(),
  status: z.number(),
  barcode: z.string().nullable(),
  basketball: z.any().nullable(),
  itemCategoryID: z.string(),
  itemDescription: z.string().nullable(),
  itemID: z.string(),
  itemName: z.string(),
  itemSubCategoryID: z.string().nullable(),
  itemTitle: z.string().nullable(),
  skuid: z.string().nullable(),
  subscriptionPackageID: z.string().nullable(),
  swimming: z.any().nullable(),
  tennis: z.any().nullable(),
  yoga: z.any().nullable(),
})

export const PackageSchema = z.object({
  id: z.string(),
  status: z.number(),
  isEditable: z.boolean(),
  activationDate: z.string(),
  additionalBenefits: z.any().nullable(),
  adults: z.boolean(),
  duration: z.number().nullable(),
  beginners: z.boolean(),
  cancellationFee: z.number(),
  cancellationFeeBase: z.number(),
  cancellationPolicy: z.any().nullable(),
  children: z.boolean(),
  customerGroupID: z.string().nullable(),
  description: z.string(),
  discount: z.number(),
  discountFixedAmount: z.number(),
  recurring: z.number(),
  earlyBirdDiscount: z.number(),
  eligibility: z.any().nullable(),
  eligibleforPoint: z.number(),
  featuresAndBenefits: z.any().nullable(),
  imagesData: z.array(z.any()),
  genericPaymentLink: z.string().nullable().optional(),
  menuDisplayOrder: z.number(),
  merchantID: z.string().nullable(),
  ofCustomers: z.number(),
  packageCategoryID: z.string().nullable(),
  packageGroupID: z.string().nullable(),
  packageName: z.string(),
  packageTypeID: z.string().nullable(),
  priceWithoutTax: z.number(),
  priceWithoutTaxBase: z.number(),
  professionals: z.boolean(),
  purchaseType: z.number(),
  ribbon: z.number(),
  salesPrice: z.number(),
  salesPriceBase: z.number(),
  skillLevel: z.any().nullable(),
  subscriptionOptions: z.number(),
  taxRate: z.number(),
  termsConditions: z.any().nullable(),
  unitPrice: z.number(),
  unitPriceBase: z.number(),
  validity: z.number(),
  visibleOnApp: z.number(),
  visibleOnCustomerPortal: z.number(),
  items: z.array(z.any()).nullable().optional(),
  infoContentData: z.array(z.any()).nullable().optional(),
  image: z.any().nullable().optional(),
  price: z.number().nullable().optional(),
  count: z.number().nullable().optional(),
  publishDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  termsAndConditions: z.string().nullable(),
})

export const PackageSchemaResponse = createDetailResponseSchema(PackageSchema)

export type Package = z.infer<typeof PackageSchema>
export type PackageResponse = z.infer<typeof PackageSchemaResponse>
